import { EChartsOption } from 'echarts';
import { Component } from '@angular/core';

@Component({
	selector: 'app-dashboard-chart-scatter',
	standalone: false,
	templateUrl: './dashboard-chart-scatter.component.html',
	styleUrl: './dashboard-chart-scatter.component.scss'
})
export class DashboardChartScatterComponent {
	options: EChartsOption = {
		tooltip: { trigger: 'item' },
		xAxis: { name: 'Risk' },
		yAxis: { name: 'Return' },
		series: [{
			type: 'scatter',
			symbolSize: 12,
			data: [
				[3.2, 8.1], [4.5, 12.3], [2.1, 5.4], [6.8, 18.2],
				[5.1, 14.7], [1.8, 4.2], [7.2, 20.1], [3.9, 9.8]
			]
		}]
	};


}
